const sort = {
  elements: [],
  init(list = {}) {
    this.sortElements(list);

    // redo equal height if it is used.
    const eqh = document.querySelectorAll('[data-equalheight]');
    if (eqh.length) {
      import(/* webpackChunkName: "equalHeight" */ './equal-height').then(({ default: equalHeight }) => {
        equalHeight.setEqualHeight(eqh);
      }).catch(() => 'An error occurred while loading the component equalHeight');
    }
  },
  sortElements(list) {
    const listArray = Array.from(list);
    //console.log(listArray);
    const groupedByContainer = {};

    listArray.forEach((element) => {
      // Get the container of the element
      const container = element.parentElement;

      // Create a unique identifier for the container
      const containerId = `${container.tagName}.${container.className}`;

      // If this container is not already in the map, initialize an empty array
      if (!groupedByContainer[containerId]) {
        groupedByContainer[containerId] = [];
      }

      // Add the element to the appropriate group
      groupedByContainer[containerId].push(element);
    });

    Object.keys(groupedByContainer).forEach((containerId) => {

      if (groupedByContainer[containerId].length > 0) {
        const sortElements = groupedByContainer[containerId];
        const container = sortElements[0].parentNode;
        const sortElementsArray = Array.from(sortElements);
        // Sort the elements by their id
        sortElementsArray.sort((a, b) => a.id.localeCompare(b.id));
        //console.log(sortElementsArray);
        // Re-append sorted elements to the container
        sortElementsArray.forEach((area) => {
          container.appendChild(area);
        });
      }
    });
  },
};

export default sort;
